import type { App } from 'vue';

export const TopLevelPagePlugin = {
	install(app: App<Element>) {
		app.mixin({
			mounted() {
				if (this.topLevel == true) {
					const mySelf = this as any;
					const appEntryComponent = this.$root;
					appEntryComponent.breadcrumbItems = mySelf.breadcrumbItems;
					appEntryComponent.menuItems = mySelf.menuItems;

					const blockers = Array.from(document.querySelectorAll<HTMLElement>('.loading-full-overlay'));
					if (blockers.length > 0) {
						const removeAll = () => {
							blockers.forEach((el) => {
								try {
									el.remove();
								} catch {}
							});
						};

						mySelf.$nextTick(() => {
							setTimeout(() => {
								blockers.forEach((el) => {
									el.classList.add('fadeOutBlocker', 'blockeranimated');
									el.addEventListener(
										'animationend',
										() => el.remove(),
										{ once: true },
									);
									// Safari historically dispatched only the prefixed variant; the
									// real animationend fires too on modern WebKit, but the prefixed
									// handler is cheap insurance for older builds.
									el.addEventListener(
										'webkitAnimationEnd',
										() => el.remove(),
										{ once: true },
									);
								});
							}, 375);

							// Safety fallback in case the animationend event never fires.
							setTimeout(removeAll, 2500);
						});
					}
				}
			},
		});
	},
};
